export default {
  certificacao: {
    descricao: 'Description',
    dataCadastro: 'Registration date',
    erroAoBuscarDados: 'Error to fetch data',
    certificacoes: 'Organic Certification',
    desejaExcluirCertificacao: 'Do you want to delete this certification',
    nao: 'No',
    excluir: 'Delete',
    certificacaoExcluida: 'Certification successfully deleted',
    erroAoExcluir: 'Error to delete certification',
    cadastroDeCertificacao: 'Organic certification registration',
    campoObrigatorio: 'Required field',
    identificacao: 'Identification',
    salvar: 'Salve',
    cancelar: 'Cancel',
    certificacaoSalvoComSucesso: 'Certification successfully saved',
    erroAoSalvar: 'Error to save certification',
    salvando: 'Saving',
    atualizando: 'Updating',
    produtorRelacionado:
      'It was not possible to exclude this certification because there is a producer using it',
    status: 'Status',
    ativo: 'Active',
    inativo: 'Inative'
  }
};
